import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { setGlobal } from 'store/global/reducer';
import styled from 'styled-components/macro';
import { getMenuAction } from 'utility/menuLookup';

const SLayout = styled.div``;

const useStyles = makeStyles((theme) => ({
    listSize: {
        fontSize: '13px',
        fontWeight: 'bold',
    },
}));

const MainDrawerItem = ({ route, isTabOpen, onListToggleOpen = () => null }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const isShowDrawer = useSelector((state) => state.global.isShowDrawer);
    const history = useHistory();
    const classes = useStyles();

    const openDrawer = async () => {
        dispatch(
            setGlobal({
                isShowDrawer: true,
            }),
        );
    };

    const getSelected = () => {
        if (isShowDrawer || route.subRoute?.length <= 0) {
            return route.path === location.pathname;
        } else {
            const prefix = location.pathname.split('/');
            const category = prefix?.[1];
            return `/${category}` === route.path;
        }
    };

    const Icon = route.icon;

    return (
        <SLayout>
            <ListItem
                button
                selected={getSelected()}
                onClick={() => {
                    if (route.subRoute?.length >= 1 && !isShowDrawer) {
                        openDrawer();
                    }

                    // if sub-route exist, notify to open drawer
                    if (route.subRoute?.length >= 1) {
                        return onListToggleOpen();
                    }

                    const customAction = getMenuAction(route.path);

                    if (customAction) {
                        return customAction();
                    }

                    // if action provided, route change is prevented
                    // if (route.action) {
                    //     return route.action();
                    // }

                    history.push(route.path);
                }}
            >
                <ListItemIcon
                    style={{
                        minWidth: 32,
                        //  color: '#dcdcdc'
                    }}
                >
                    <Icon />
                </ListItemIcon>
                <ListItemText
                    primary={route?.getName?.() ?? route.name}
                    style={{ color: '#15426B' }}
                    classes={{ primary: classes.listSize }}
                />
                {route.subRoute?.length >= 1 &&
                    (isTabOpen ? (
                        <ExpandLess style={{ color: '#808080' }} />
                    ) : (
                        <ExpandMore style={{ color: '#808080' }} />
                    ))}
            </ListItem>
        </SLayout>
    );
};

export default MainDrawerItem;
